import { createFileRoute } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { OrderHistorySearch } from '@/features/activity-log/components/order-history-search'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/activity-log/')({
  component: () => (
    <Main>
      <RequirePermission permission='activity-log.view'>
        <OrderHistorySearch />
      </RequirePermission>
    </Main>
  ),
})
